<div class="modal inmodal fade in create-modal show">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title col-sm-8">Image</h3>
                <button type="button" class="close" (click)="hideModal(true)">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
            </div>
            <div class="modal-body">
                <video [hidden]="image" id="player" autoplay></video>
                <canvas [hidden]="!image || croppedImageFile" id="canvas" width="430" height="320"></canvas>
                <image-cropper *ngIf="image"
                               [imageBase64]="image"
                               [maintainAspectRatio]="true"
                               [aspectRatio]="1"
                               [resizeToWidth]="300"
                               [resizeToHeight]="300"
                               format="png"
                               (imageCropped)="imageCropped($event)"
                               (loadImageFailed)="loadImageFailed($event)"
                               [roundCropper]="true">
                </image-cropper>

                <button [hidden]="image" id="capture" class="btn mtv-primary-border mtv-primary-color m-t-sm">Capture</button>
                <div [hidden]="!croppedImageFile" class="row text-center m-t-sm">
                    <button class="btn mtv-primary-border mtv-primary-color"
                            type="button"
                            [disabled]="disabledSave"
                            (click)="image = ''; croppedImageFile = '';">
                        Retake
                    </button>
                    <button class="btn btn-primary submit-btn"
                            type="button"
                            [disabled]="disabledSave"
                            (click)="hideModal(false)">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal(true)"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/directory/capture-image-modal/capture-image-modal.component.html